export default {
  filterAlarmsButtonLabel: 'Filtruj alarmy',
  filterTimeBucketLabel: 'Granularność',
  paretoOccurrences: 'Pareto',
  paretoDuration: 'Pareto',
  table: 'Statystyki alarmów',
  gantt: 'Oś czasu',
};
